
<svg id="planContainer" style="user-select: none; transition: all 1s; filter: 'grayscale(1) blur(2px)'" #svgComponent>
    <app-polygon-factory *ngIf="shouldExecutePolygonFactory" [floorType]=floortype [data]="geoJsonData"
        [svgComponent]="svgComponent" [layout]="layout">
    
    </app-polygon-factory>
    <app-svg-factory *ngIf="shouldExecuteSVGFactory" (finishedSVGInjection)="finishedSVGInjection($event)" [seatID]="seatID" [FLOOR_DATA]="FLOOR_DATA"
        [floorType]="floortype" [data]="geoJsonData" [svgComponent]="svgComponent" [floorDetails]="floorDetails" [empGuid]="empGuid">
    
    </app-svg-factory>
    <lib-interactions-injection *ngIf="shouldExecuteInteractionsInjector" (finishedInteractionsInjection)="finishedInteractionsInjection($event)"
        [svgComponent]="preRenderedPlan ? preRenderedPlan : svgComponent" [mouseEvent]="mouseEvent" [floorDetails]="floorDetails"
        [data]="geoJsonData" [floorType]="floortype" [seatID]="seatID">
    
    </lib-interactions-injection>

</svg>
                
